import { render } from "./Paginate.vue?vue&type=template&id=72ed5fe1&scoped=true&lang=pug"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=72ed5fe1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ed5fe1"],['__file',"src/common/pagination/Paginate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72ed5fe1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72ed5fe1', __exports__)) {
    api.reload('72ed5fe1', __exports__)
  }
  
  module.hot.accept("./Paginate.vue?vue&type=template&id=72ed5fe1&scoped=true&lang=pug", () => {
    api.rerender('72ed5fe1', render)
  })

}


export default __exports__